import { render, staticRenderFns } from "./AddNewUserDialog.vue?vue&type=template&id=2dea2372&scoped=true"
import script from "./AddNewUserDialog.vue?vue&type=script&lang=js"
export * from "./AddNewUserDialog.vue?vue&type=script&lang=js"
import style0 from "./AddNewUserDialog.vue?vue&type=style&index=0&id=2dea2372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea2372",
  null
  
)

export default component.exports